import fs from 'node:fs'
import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import { stringifyProjectJson } from '@cli-utils/shared.js'
import { manifestPath } from './manifest-path.js'
import { scopeDir } from './scope-dir.js'

export function saveManifest(cwd: string, scope: string, manifest: SnapshotManifest): void {
  fs.mkdirSync(scopeDir(cwd, scope), { recursive: true })
  fs.writeFileSync(manifestPath(cwd, scope), stringifyProjectJson(manifest), 'utf-8')
}
